import React, { SFC } from 'react'

import './activity-indicator.scss'

export const ActivityIndicator: SFC = () => {
  return <span className="activity-indicator__dot anim--notify" />
}



// WEBPACK FOOTER //
// ./src/app/shared/components/activity-indicator.tsx